// export type ServiceProviderKey = 'beam' | 'qrcode';
export type ServiceProviderKey = 'beam';

export interface ServiceProviderDef {
  key: ServiceProviderKey;
  name: string; // ชื่อแบรนด์ (แสดงตรงๆ ไม่แปล)
  subtitleKey: string; // คำอธิบายสั้นใต้ icon (i18n key)
  descriptionKey: string; // คำอธิบายบริการ (i18n key)
  registerUrl?: string; // ลิงก์สมัครใช้งาน
  icon: string; // remix icon
  logoSrc?: string; // static logo path served from public
}

// รายการ credential/token หนึ่งชุดที่เชื่อมต่อไว้
export interface ServiceConnection {
  id: number;
  provider: ServiceProviderKey;
  merchantId: string; // Merchant ID (ต้องไม่ซ้ำ)
  keyName: string; // ชื่อ Key (Secret Key)
  apiKey: string; // API Key
  bankAccountNumber: string; // เลขบัญชีธนาคาร
  bankAccountName: string; // ชื่อบัญชีธนาคาร
  bankCode: string; // ธนาคาร
  isActive: boolean; // สถานะการใช้งาน
  createdAt: string; // ISO date string from backend created_at
}

// ข้อมูลที่กรอกในฟอร์มเพิ่มการเชื่อมต่อ (สร้างได้ทั้งชุด แต่แก้ไขได้แค่ isActive)
export interface ServiceConnectionFormValues {
  merchantId: string;
  keyName: string;
  apiKey: string;
  secretKey: string;
  bankAccountNumber: string;
  bankAccountName: string;
  bankCode: string;
}

export interface ServiceConnectionBank {
  code: string;
  nameTh: string;
  nameEn: string;
  assetPath: string;
  assetUrl: string;
}

export const SERVICE_CONNECTION_LIMIT = 10;
